import { useState } from 'react';
import { SAVE_STATUS } from 'edrolo/constants/SaveStatus';
import { useLocalStorage } from 'core/hooks/useLocalStorage';

export const useDemoActivityResponse = (activityId) => {
  const [status] = useState(SAVE_STATUS.SAVED);

  const defaultActivityResponsePostData = {
    block_responses: {},
    collaborators: [],
    ready_for_review: false,
  };

  const [activityResponse, setActivityResponse] = useLocalStorage(
    `activityResponse-${activityId}`,
    defaultActivityResponsePostData
  );

  return {
    activityResponse,
    activityResponseError: null,
    status,
    activityResponseIsLoading: false,
    saveActivityResponse: setActivityResponse,
    responseSaveError: false,
  };
};
